export default __webpack_public_path__ + "static/everything-bfd1e36bf7119b11f407e78cca1bbef6.png";